/**
 * @flow
 * @relayHash 7087fa6721042e65576b7023c7bfd786
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ResendCompleteStaffAccountEmailInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type ResendCompleteStaffAccountEmailMutationVariables = {|
  input: ResendCompleteStaffAccountEmailInput
|};
export type ResendCompleteStaffAccountEmailMutationResponse = {|
  +resendCompleteStaffAccountEmail: ?{|
    +emailSent: ?boolean
  |}
|};
export type ResendCompleteStaffAccountEmailMutation = {|
  variables: ResendCompleteStaffAccountEmailMutationVariables,
  response: ResendCompleteStaffAccountEmailMutationResponse,
|};
*/


/*
mutation ResendCompleteStaffAccountEmailMutation(
  $input: ResendCompleteStaffAccountEmailInput!
) {
  resendCompleteStaffAccountEmail(input: $input) {
    emailSent
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ResendCompleteStaffAccountEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "resendCompleteStaffAccountEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResendCompleteStaffAccountEmailPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "emailSent",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ResendCompleteStaffAccountEmailMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ResendCompleteStaffAccountEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ResendCompleteStaffAccountEmailMutation",
    "id": null,
    "text": "mutation ResendCompleteStaffAccountEmailMutation(\n  $input: ResendCompleteStaffAccountEmailInput!\n) {\n  resendCompleteStaffAccountEmail(input: $input) {\n    emailSent\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bad0ac9c4036290cda53faecaf9a9fcd';
module.exports = node;
